import { Session } from '@yandex-video-platform/goloom-sdk';
import { call, put } from 'typed-redux-saga';

import { logger } from '.';
import { configSlice } from '..';

function* setWebRtcCapabilities() {
    try {
        const webRtcCapabilities = yield* call(Session.getWebRtcCapabilities);

        yield put(configSlice.actions.setWebRtcCapabilities(webRtcCapabilities));
    } catch (error) {
        logger.error(error, {
            method: 'setWebRtcCapabilities',
        });
    }
}

export default setWebRtcCapabilities;
